/**
 * Constante des codes de statut HTTP
 */
export class StatusCodeConstant {
	public static readonly FORBIDDEN = 403;
	public static readonly INTERNAL_SERVER_ERROR = 500;
}
